import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import { makeSideBarActive } from "../../utils/ellowutils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import * as CONSTANTS from "../../utils/CONSTANTS";
import Tab from "../../compopnents/tab";
import Styles from "./styles.module.scss";
import TimeSheetTab from "./timeSheet";
import { useLocation } from "react-router-dom";
import { getTimesheetListforcustomer , getHistory } from "./service";
import CheckHistory from "../../modal/checkHistory";
  

function TimeSheet() {

    const location = useLocation();
    const { candidateJobId }: any = location.state || ''
    const { jobTitle }: any = location.state || ''
    const {  name } :any = location.state || ''

    const BreadcrumsValues = [jobTitle];
    const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);

    const [selected, setSelected] = useState<number>(0);
    const [customerId, setCustomerId] = useState<any>(localStorage.getItem('customerId'))
    const [data , setData] = useState<any>()
    const [filterValues, setFilterValues] = useState<any>(null);
    const [historyModal, setHistoryModal] = useState<boolean>(false)
    const [checkHistoryData, setCheckHistoryData] = useState<any>()

    const handleSelect = (e: TabStripSelectEventArguments) => {
      setSelected(e.selected);
    };
  
    useEffect(() => {
        getTimesheet(1, 25, "",""," ")
    },[])
    

    const getTimesheet = (
        pageNumber: number,
        pageSize: number,
        searchValue: string,
        filters?: any,
        sort?:any
      ) => {
       
        let data = {};
        
        if(filters){ 
            data = {
                candidateJobId : candidateJobId,
                filters : filters,
                sort: {
                    sortBy: "duration",
                    sortOrder: "desc"
                }
            }
        }else{
            data = {
            candidateJobId : candidateJobId,
            filters: {
                "statusList":[2,3,4]
            },
            sort: {
                sortBy: "duration",
                sortOrder: "desc"
            }
            }
        }   
        getTimesheetListforcustomer(searchValue , pageNumber, pageSize, data).then((response) => { 
            if(response && response.status === 1){
                setData(response.data)
            }
        })
    }

    const applyFilter = (data: any) => {
  
        let filters = {
            projectName: data.projectName !== "" ? data.projectName : undefined,
            reportingManager: data.reportingManager !== "" ? data.reportingManager : undefined,
            status: data.status !== undefined ?  data.status.name : data.status,
            dateWithin: data.duration  ?  { from: data.duration.startDateFrom, to:  data.duration. endDateFrom } : undefined
        }
        setFilterValues(filters)
        let value = {
            "statusList":[2,3,4],
            "projectName": data.projectName !== "" ? data.projectName : undefined,
            "reportingManager": data.reportingManager !== "" ? data.reportingManager : undefined,
            "status": data.status !== undefined ?  data.status.id : data.status,
            "duration": data.duration      
        } 
        getTimesheet(1,25,"",value,"")
    }

    const closeTag = (data: any) => { 
       applyFilter(data)
      }

    const pageChange = (pageSize: number, pageNumber: number) => {
     
    }
    
    const searchChange = (e: any) => {
    
    }

    const getHistoryDetails = (timesheetId: string) => {
        getHistory(timesheetId).then((response) => {
          if (response && response.status === 1) {
            setCheckHistoryData(response.data)
          }
        })
      }

    const showHistory = (data: any) => {
        setHistoryModal(true)
        getHistoryDetails(data.timesheetId)
      }
  
    return (
        <section className="dashboardWrapper">
            <SideMenu menu={menu} />
            <div className="dashboardContent">
                <DashboardHeader
                    title={BreadcrumsValues}
                    searchChange={searchChange}
                    name={name}
                    applyFilter={applyFilter}
                    filterValues={filterValues}
                    closeTag={closeTag}
                    type='timeSheet'
                />
            <section className={Styles.timeSheetWrapper}>
                
                <TimeSheetTab data={data} showHistory={showHistory}/>
            </section>
            {historyModal && <CheckHistory onClose={() => setHistoryModal(false)} data={checkHistoryData} sendReminder={''} />}
            </div>
        </section>
    )
  }
export default TimeSheet;
  